import { Link } from "react-router";
import { routes } from "../../app/routes";
import { DonateButton } from "./DonateButton";
import { NavLinks } from "./NavLinks";
import { OrlaMark } from "../../platform/brand/OrlaMark";
import "./navigation.css";

export function SiteNav() {
  return (
    <header className="site-nav">
      <a className="site-nav__skip" href="#main">
        Skip to content
      </a>
      <Link to={routes.home()} className="site-nav__home" aria-label="Orla, home">
        <OrlaMark />
      </Link>
      <nav className="site-nav__links" aria-label="Main">
        <NavLinks />
      </nav>
      <div className="site-nav__donate">
        <DonateButton />
      </div>
    </header>
  );
}
